import { SeoType, SORTS } from '@/types';

export const BACKEND_URL = process.env.BACKEND_URL;
export const FRONT_URL = process.env.FRONT_URL;
export const PAYMENT_METHOD = process.env.PAYMENT_METHOD;
export const NEXTAUTH_SECRET = process.env.NEXTAUTH_SECRET;
export const DADATA_API_KEY = process.env.DADATA_API_KEY;
export const ZETA_TERMINAL_ID = process.env.ZETA_TERMINAL_ID;
export const NEXTAUTH_URL = process.env.NEXTAUTH_URL;

export const MOBILE_RESOLUTION = 440;
export const TABLET_RESOLUTION = 1024;
export const SMALL_TABLET_RESOLUTION = 768;

export const EMPTY_META = {
  id: '',
  page: '',
  enabled: false,
  createdAt: '',
  updatedAt: '',
  title: { kz: 'Zeta', ru: 'Zeta', en: 'Zeta' },
  text: { kz: 'Zeta', ru: 'Zeta', en: 'Zeta' },
  image: '',
  canonical: '',
  keywords: '',
  robots: '',
} as SeoType;

export const USER_CITY_FIELD = 'USER_CITY';

export const DELIVERY_TABS = [
  {
    label: 'Доставка',
    id: 'delivery',
  },
  {
    label: 'Оплата',
    id: 'payment',
  },
  {
    label: 'Гарантия',
    id: 'guarantee',
  },
  {
    label: 'Рассрочка',
    id: 'installment',
  },
];

export const PASSWORD_REGEX =
  /^^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()-_=+{};:,.<>?]{8,}$/;

// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX = /[A-Za-z0-9\._%+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,}/;

export const PHONE_REGEX = /\d{3}\s?\d{3}-\d{2}-\d{2}/;

export const NAME_REGEX = /^[a-zA-Zа-яА-ЯёЁәіңғүұқөһӘІҢҒҮҰҚӨҺ\s]+$/;

export const MESSAGE_REGEX = /^[a-zA-Zа-яА-ЯёЁ0-9\s.,!?-]+$/;

export const NUMBER_REGEX = /^[0-9]+$/;

export const BIRTHDATE_REGEX = /^\d{2}\.\d{2}\.\d{4}$/;

export const MOCK_IMAGE = '/png/empty.png';
export const MOCK_TEXT =
  'Lorem ipsum dolor sit amet consectetur. Pulvinar mauris arcu gravida mattis molestie porttitor. ';

export const CONTENT_CLASSNAME = 'content';

export const CONTENT_SPACE_CLASSNAME = 'content space';

export const ABOUT_TABS = [
  {
    label: 'О компании',
    id: 'about',
  },
  {
    label: 'О производстве',
    id: 'manufacture',
  },
];

export const MENU_LINKS = [
  {
    name: 'Интерьеры',
    url: '/interiors',
  },
  {
    name: 'Магазины',
    url: '/shops',
  },
  {
    name: 'Программа лояльности',
    url: '/loyalty',
  },
  {
    name: 'Наши партнеры',
    url: '/partners',
  },
  {
    name: 'О компании',
    url: '/about',
  },
  {
    name: 'Новости',
    url: '/news',
  },
];

export const OTHER_LINKS = [
  {
    name: 'Вопрос ответ',
    url: '/faq',
  },
  {
    name: 'Доставка',
    url: '/delivery',
  },
  {
    name: 'Оплата',
    url: '/payment',
  },
  {
    name: 'Рассрочка',
    url: '/installment',
  },
  {
    name: 'Гарантия',
    url: '/guarantee',
  },
  {
    name: 'Контакты',
    url: '/contacts',
  },
];

export const DELIVERY_INFO_ROWS = [
  'По городу',
  'Стоимость доставки по одному адресу в Алматы — 5 000 ₸ независимо от общей суммы покупки.',
  'Крупногабаритный товар',
  'Доставка крупногабаритного товара или объёмного товара - 12 800 ₸ по одному адресу.',
  'За пределами города',
  'Уточняйте у менеджеров интернет-магазина.',
];

export const SORTS_MAP = {
  [SORTS.Popular]: 'Популярные',
  [SORTS.Discount]: 'По размеру скидки',
  [SORTS.Suit]: 'Наиболее подходящие',
  [SORTS.Cheap]: 'Самые дешевые',
  [SORTS.Expensive]: 'Самые дорогие',
  [SORTS.New]: 'Новинки',
  [SORTS.Search]: 'По релевантности',
};

export enum ORDER_SORTS {
  NewFirst = 'new',
  OldFirst = 'old',
  ExpensiveFirst = 'expensive',
  CheapFirst = 'cheap',
}

export const ORDER_SORTS_MAP = {
  [ORDER_SORTS.NewFirst]: 'Сначала новые',
  [ORDER_SORTS.OldFirst]: 'Сначала старые',
  [ORDER_SORTS.ExpensiveFirst]: 'Сначала дорогие',
  [ORDER_SORTS.CheapFirst]: 'Сначала дешевые',
};

export const ELEMENT_COUNT = 12;

export const SAVED_SEARCH_HISTORY = 'SAVED_SEARCH_HISTORY';

export const SUGGESTIONS = [
  'кровать',
  'стул',
  'диван',
  'офисное кресло',
  'скамья',
];
